"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dynos = dynos;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _underscore = require("underscore");

var _TableSorting = _interopRequireDefault(require("lead-flows-ui/constants/TableSorting"));

var _FlowsTableProperties = _interopRequireDefault(require("lead-flows-ui/constants/FlowsTableProperties"));

var _DynoUtils = require("lead-flows-ui/utils/DynoUtils");

var INITIAL_STATE = {
  dynos: {
    table: {
      col: _FlowsTableProperties.default.CREATED_AT.columnName,
      dir: _TableSorting.default.asc,
      search: '',
      searched: true
    },
    isFetching: false,
    fetchingHasError: false,
    fetchingRecentError: undefined,
    lastFetched: undefined,
    analyticsHasError: false,
    dynosById: {},
    guidToId: {},
    totalCount: undefined,
    failedToGetDynoByGuid: false,
    isCreatingNewDyno: false,
    dynoCreationHasError: false,
    analytics: {},
    analyticsIsLoading: true,
    offset: 0
  }
};

var defaultDynoMixin = function defaultDynoMixin(dyno) {
  return Object.assign({}, dyno, {
    isSubmitting: false,
    submittingHasError: false,
    submittingRecentError: undefined
  });
};

function dynos() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE.dynos;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.REQUEST_DYNOS:
      return Object.assign({}, state, {
        isFetching: true
      });
    // eslint-disable-next-line no-case-declarations

    case _ActionTypes.RECEIVE_DYNOS:
      var guidToId = state.guidToId || {};
      action.payload.dynos.forEach(function (d) {
        return guidToId[d.formGuid] = d.id;
      });

      if (!state.table.searched) {
        state.dynosById = {}; // reset for search results
      }

      return Object.assign({}, state, {
        isFetching: false,
        fetchingHasError: false,
        lastFetched: action.meta.timestamp,
        dynosById: Object.assign({}, state.dynosById, (0, _underscore.indexBy)((0, _underscore.map)(action.payload.dynos, defaultDynoMixin), 'id')),
        table: {
          col: state.table.col,
          dir: state.table.dir,
          search: state.table.search,
          searched: true
        },
        totalCount: action.payload.totalCount,
        offset: action.payload.offset + action.payload.dynos.length,
        hasMore: action.payload.hasMore,
        guidToId: guidToId
      });

    case _ActionTypes.ERROR_DYNOS:
      return Object.assign({}, state, {
        isFetching: false,
        fetchingHasError: true,
        fetchingRecentError: action.payload
      });

    case _ActionTypes.REQUEST_DYNOS_ANALYTICS:
      return Object.assign({}, state, {
        analyticsIsLoading: true
      });
    // eslint-disable-next-line no-case-declarations

    case _ActionTypes.RECEIVE_DYNOS_ANALYTICS:
      // Payload is a 4-element array:
      // [0] contains details on form views, submissions etc
      // [1] contains an array of counts of contacts gathered
      // [2] contains the corresponding form guids to those counts
      // [3] is a string describing the date range covered by the data
      var analytics = state.analytics;
      var rangeTag = action.payload[3];
      var dataPresent = action.payload.every(function (analytic) {
        return Boolean(analytic);
      });

      if (dataPresent) {
        var formAnalytics = [];

        if (action.payload[0].breakdowns) {
          action.payload[0].breakdowns.forEach(function (b) {
            formAnalytics[b.breakdown] = typeof b.formViews !== 'undefined' ? b.formViews : 0;
          });
        }

        var formGuids = action.payload[2];
        var contactsAnalytics = (0, _underscore.object)(formGuids, action.payload[1]);
        var dateRangeAnalytics = analytics[rangeTag] || {};
        dateRangeAnalytics = (0, _underscore.reduce)(formGuids, function (overall, guid) {
          var views = formAnalytics[guid] || 0;
          var contacts = contactsAnalytics[guid].count;
          overall[guid] = {
            views: views,
            contacts: contacts,
            conversion: (0, _DynoUtils.calculateConversion)(contacts, views)
          };
          return overall;
        }, dateRangeAnalytics);
        analytics[rangeTag] = dateRangeAnalytics;
      }

      return Object.assign({}, state, {
        analyticsHasError: !dataPresent,
        analyticsIsLoading: false,
        analytics: analytics
      });

    case _ActionTypes.ERROR_DYNOS_ANALYTICS:
      return Object.assign({}, state, {
        analyticsHasError: true,
        analyticsIsLoading: false
      });

    case _ActionTypes.REQUEST_DYNO_BY_ID:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _ActionTypes.REQUEST_DYNO_CREATION:
      return Object.assign({}, state, {
        isCreatingNewDyno: true
      });

    case _ActionTypes.REPORT_DYNO_CREATION_ERROR:
      return Object.assign({}, state, {
        isCreatingNewDyno: false,
        dynoCreationHasError: true
      });

    case _ActionTypes.CLEAR_DYNO_CREATION_ERROR:
      return Object.assign({}, state, {
        dynoCreationHasError: false
      });

    case _ActionTypes.CREATE_DYNO_SUCCESS:
      return Object.assign({}, state, {
        isCreatingNewDyno: false
      });
    // eslint-disable-next-line no-case-declarations

    case _ActionTypes.RECEIVE_DYNO_BY_ID:
      var updatedDynos = (0, _underscore.clone)(state.dynosById);
      var dyno = state.dynosById[action.payload.id];
      updatedDynos[action.payload.id] = Object.assign({}, dyno, defaultDynoMixin(action.payload));
      return Object.assign({}, state, {
        isFetching: false,
        fetchingHasError: false,
        dynosById: updatedDynos
      });

    case _ActionTypes.ERROR_DYNO_BY_ID:
      return Object.assign({}, state, {
        isFetching: false,
        fetchingHasError: true,
        fetchingRecentError: action.payload
      });

    case _ActionTypes.SAVE_DYNO_SUCCESS:
      return Object.assign({}, state, {
        dynosById: Object.assign({}, state.dynosById, (0, _defineProperty2.default)({}, action.payload.id, Object.assign({}, state.dynosById[action.payload.id], defaultDynoMixin(action.payload))))
      });

    case _ActionTypes.REQUEST_DYNO_ENABLE_SWITCH:
      return Object.assign({}, state, {
        dynosById: Object.assign({}, state.dynosById, (0, _defineProperty2.default)({}, action.id, Object.assign({}, state.dynosById[action.id], {
          isSubmitting: true
        })))
      });

    case _ActionTypes.RECEIVE_DYNO_ENABLE_SWITCH:
      return Object.assign({}, state, {
        dynosById: Object.assign({}, state.dynosById, (0, _defineProperty2.default)({}, action.id, Object.assign({}, state.dynosById[action.id], {
          isSubmitting: false,
          submittingHasError: false
        })))
      });

    case _ActionTypes.ERROR_DYNO_ENABLE_SWITCH:
      return Object.assign({}, state, {
        dynosById: Object.assign({}, state.dynosById, (0, _defineProperty2.default)({}, action.id, Object.assign({}, state.dynosById[action.id], {
          isSubmitting: false,
          submittingHasError: true,
          submittingRecentError: action.payload
        })))
      });

    case _ActionTypes.REMOVE_ERROR_DYNO_ENABLED_SWITCH:
      return Object.assign({}, state, {
        dynosById: Object.assign({}, state.dynosById, (0, _defineProperty2.default)({}, action.id, Object.assign({}, state.dynosById[action.id], {
          isSubmitting: false,
          submittingHasError: false
        })))
      });

    case _ActionTypes.UPDATE_DYNOS_TABLE_SORTING:
      return Object.assign({}, state, {
        table: {
          col: action.col,
          dir: action.dir
        },
        offset: 0
      });

    case _ActionTypes.UPDATE_DYNOS_TABLE_SEARCH:
      return Object.assign({}, state, {
        table: {
          col: state.table.col,
          dir: state.table.dir,
          search: action.search,
          searched: false
        },
        offset: 0
      });

    case _ActionTypes.FETCH_DYNO_BY_GUID:
      return Object.assign({}, state, {
        failedToGetDynoByGuid: false
      });

    case _ActionTypes.FAILED_TO_GET_DYNO_BY_GUID:
      return Object.assign({}, state, {
        failedToGetDynoByGuid: true
      });

    case _ActionTypes.REQUEST_DYNO_DELETE:
      return state;

    case _ActionTypes.RECEIVE_DYNO_DELETE:
      return Object.assign({}, state, {
        dynosById: Object.assign({}, (0, _underscore.omit)(state.dynosById, action.payload.id.toString()))
      });

    case _ActionTypes.REQUEST_DYNO_CLONE:
      return state;

    case _ActionTypes.RECEIVE_DYNO_CLONE:
      return Object.assign({}, state, {
        dynosById: Object.assign({}, state.dynosById, (0, _defineProperty2.default)({}, action.payload.id, Object.assign({}, state.dynosById[action.payload.id], defaultDynoMixin(action.payload))))
      });

    case _ActionTypes.ERROR_DYNO_DELETE:
      return Object.assign({}, state, {
        dynosById: Object.assign({}, state.dynosById, (0, _defineProperty2.default)({}, action.id, Object.assign({}, state.dynosById[action.payload.id], {
          deletingHasError: true,
          deletingRecentError: action.payload
        })))
      });

    case _ActionTypes.REMOVE_ERROR_DYNO_DELETE:
      return Object.assign({}, state, {
        dynosById: Object.assign({}, state.dynosById, (0, _defineProperty2.default)({}, action.id, Object.assign({}, state.dynosById[action.id], {
          deletingHasError: false
        })))
      });

    case _ActionTypes.DELETE_DRAFT_SUCCESS:
      return Object.assign({}, state, {
        dynosById: Object.assign({}, (0, _underscore.omit)(state.dynosById, action.payload.id.toString()))
      });

    default:
      return state;
  }
}